module.exports = require('./appWindowHelpers')
